import { useState, useEffect, useCallback } from 'react'
import { Spinner } from '@chakra-ui/react'

export default ({
  source, template, r = 50, style, id,
}) => {
  const [data, setData] = useState()
  const load = useCallback(async () => {
    const res = await fetch(source)
    setData(await res.json())
  }, [source])

  useEffect(() => { load() }, [load])

  let input = data
  if(!input) {
    input = new Array(10)
    template = () => <Spinner/>
  }

  const arc = 2 * Math.PI / input.length

  return (
    <g {...{ id }}>
      <circle {...{ r, style }}/>
      {input.map((datum, i) => {
        const dx = r * Math.cos(arc * i)
        const dy = r * Math.sin(arc * i)
        return (
          <g
            key={i}
            className="position"
            transform={`translate(${dx}, ${dy})`}
          >
            {template(datum)}
          </g>
        )
      })}
    </g>
  )
}  